<template>
	<div class="sa-flexbox">
		<div class="sa-flexbox-header">
			<div class="sa-flexbox-body-container"></div>
		</div>
		<div class="sa-flexbox-body">
			<div class="sa-flexbox-body-container">
				<div class="sa-flexbox-body-container-content">
					<b-row>
						<b-col cols="12" md="3" class="sa-flexbox-body-container-content-left">
							<b-card no-body class="shadow-sm">
								<b-card-header class="bg-dark text-white py-2 font-weight-bold">Metadati</b-card-header>
								<b-card-body class="p-3">
									<div v-for="campo in campiDisponibili" :key="campo.uid" draggable="true" @dragstart="onDragStartFromSource($event, campo)" class="sa-dataanalysis-pivot-field-source border" :class="'sa-dataanalysis-pivot-field-source-' + campo.tipo.toLowerCase()">
										<div class="d-flex justify-content-between align-items-center">
											<span>{{ campo.label }}</span>
											<span class="sa-dataanalysis-pivot-type-tag">{{ campo.tipo }}</span>
										</div>
									</div>
								</b-card-body>
							</b-card>
							<b-card no-body class="shadow-sm">
								<b-card-header class="bg-dark text-white py-2 font-weight-bold">Filtri</b-card-header>
								<b-card-body class="p-3">
									<div v-for="f in availableFilters" :key="f.uid" class="sa-dataanalysis-pivot-filter">
										<div class="d-flex justify-content-between align-items-center">
											<b-dropdown size="sm" variant="outline-secondary" class="mr-2" no-caret>
												<template #button-content>
													{{ f.label }} <b-badge v-if="activeFilters[f.uid].length" variant="primary" pill>{{ activeFilters[f.uid].length }}</b-badge>
												</template>
												<div class="sa-dataanalysis-pivot-dropdown-filter-content">
													<b-form-checkbox-group v-model="activeFilters[f.uid]" stacked>
														<b-form-checkbox v-for="opt in filterOptions[f.uid]" :key="opt.value" :value="opt.value">
															{{ opt.text }}
														</b-form-checkbox>
													</b-form-checkbox-group>
												</div>
											</b-dropdown>
										</div>
									</div>
								</b-card-body>
							</b-card>
							<!-- <div class="sa-dataanalysis-filter-bar shadow-sm">
								<span class="text-muted small font-weight-bold mr-2"><i class="mdi mdi-filter"></i> FILTRI:</span>
								<b-dropdown v-for="f in availableFilters" :key="f.uid" size="sm" variant="outline-secondary" class="mr-2" no-caret>
									<template #button-content>
										{{ f.label }} <b-badge v-if="activeFilters[f.uid].length" variant="primary" pill>{{ activeFilters[f.uid].length }}</b-badge>
									</template>
									<div class="dropdown-filter-content">
										<b-form-checkbox-group v-model="activeFilters[f.uid]" stacked>
											<b-form-checkbox v-for="opt in filterOptions[f.uid]" :key="opt.value" :value="opt.value">
												{{ opt.text }}
											</b-form-checkbox>
										</b-form-checkbox-group>
									</div>
								</b-dropdown>
							</div> -->
						</b-col>

						<b-col cols="12" md="9" class="sa-flexbox-body-container-content-center">
							<b-card class="mb-4 shadow-sm">
								<b-row>
									<b-col v-for="zona in ['righe', 'colonne', 'misure']" :key="zona" md="4">
										<label class="small font-weight-bold text-uppercase text-muted">{{ zona }}</label>
										<div :class="'sa-dataanalysis-pivot-drop-zone-' + zona" class="sa-dataanalysis-pivot-drop-zone" @dragover.prevent="onDragOver" @dragleave="onDragLeave" @drop="onDropMain($event, zona)">
											<div v-if="config[zona].length === 0" class="text-center text-muted small mt-4">Trascina qui i campi</div>

											<div v-for="(item, i) in config[zona]" :key="i" draggable="true" @dragstart="onDragStartBadge($event, zona, i)" @drop.stop="onDropBadge($event, zona, i)" class="sa-dataanalysis-pivot-badge">
												<div class="sa-dataanalysis-pivot-badge-content">
													<b-badge variant="info" pill class="p-2 d-flex align-items-center sa-dataanalysis-pivot-badge">
														{{ item.label }}
														<span class="sa-dataanalysis-pivot-badge-icon" @click="rimuovi(zona, i)"><i class="fas fa-times-circle" style="cursor: pointer"></i></span>
													</b-badge>

													<div v-if="zona === 'misure'" class="mt-1 px-1">
														<select v-model="item.aggregazione" class="custom-select">
															<option value="SUM">SUM</option>
															<option value="AVG">AVG</option>
															<option value="COUNT">COUNT</option>
														</select>
													</div>
												</div>
											</div>
										</div>
									</b-col>
								</b-row>
								<b-button block variant="primary" class="mt-4 font-weight-bold" @click="analizza" :disabled="config.righe.length === 0"> <i class="mdi mdi-play mr-1"></i> ESEGUI ANALISI </b-button>
							</b-card>

							<div v-if="mostraTabella" class="sa-dataanalysis-pivot-table-responsive bg-white border rounded shadow-sm">
								<table class="table table-sm sa-dataanalysis-pivot-table" :key="keyPivotTable">
									<!-- <thead>
										<tr>
											<th class="sa-dataanalysis-pivot-header-cat" :rowspan="config.colonne.length" :colspan="config.righe.length" style="vertical-align: middle">
												{{ config.righe.map((r) => r.label).join(" / ") }}
											</th>
											<th v-for="group in columnGroups" :key="group.name" class="sa-dataanalysis-pivot-header-cat" :colspan="group.span">
												{{ group.name }}
											</th>
											<th class="sa-dataanalysis-pivot-header-cat" :rowspan="config.colonne.length" style="vertical-align: middle; background-color: rgb(106, 106, 106) !important">TOTALE</th>
										</tr>
										<tr v-for="level in config.colonne.length - 1" :key="'lvl-' + level">
											<th v-for="col in flatColumnHeaders" :key="col.id" class="sa-dataanalysis-pivot-header-label">
												{{ col.labels[level] }}
											</th>
										</tr>
									</thead> -->
									<thead>
										<tr v-for="(row, levelIndex) in headerRows" :key="'row-' + levelIndex">
											<th v-if="levelIndex === 0" class="sa-dataanalysis-pivot-header-cat" :rowspan="config.colonne.length" :colspan="config.righe.length">
												{{ config.righe.map((r) => r.label).join(" / ") }}
											</th>

											<th v-for="(col, colIndex) in row" :key="colIndex" class="sa-dataanalysis-pivot-header-cat" :class="levelIndex > 0 ? 'sa-dataanalysis-pivot-header-label' : ''" :colspan="col.span">
												{{ col.name }}
											</th>

											<th v-if="levelIndex === 0" class="sa-dataanalysis-pivot-header-cat" :rowspan="config.colonne.length">TOTALE</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="row in pivotedData" :key="row.rowKey">
											<td v-for="r in config.righe" :key="r.uid" class="sa-dataanalysis-pivot-td-dim">
												{{ row.dims[r.uid] || "N.D." }}
											</td>
											<td v-for="col in flatColumnHeaders" :key="col.id" class="sa-dataanalysis-pivot-td-val">
												{{ row.cells[col.id] || "-" }}
											</td>
											<td class="sa-dataanalysis-pivot-td-total">
												{{ row.rowTotal }}
											</td>
										</tr>
									</tbody>
								</table>
								<!-- <table class="table table-sm sa-dataanalysis-pivot-table mb-0">
								<thead>
									<tr>
										<th v-for="r in config.righe" :key="'hr-' + r.uid">{{ r.label }}</th>
										<th v-for="h in flatHeaders" :key="h.key">{{ h.title }}</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(row, idx) in dati" :key="idx">
										<td v-for="r in config.righe" :key="'cr-' + r.uid" class="sa-dataanalysis-pivot-td-dimension">
											{{ row.dims[r.label] }}
										</td>
										<td v-for="h in flatHeaders" :key="'cm-' + h.key" class="sa-dataanalysis-pivot-td-measure">
											{{ row.vals[h.key] }}
										</td>
									</tr>
								</tbody>
							</table> -->
							</div>
						</b-col>
					</b-row>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
export default {
	data() {
		return {
			pathResource: "/dataanalysisdatabaseinfo/eseguipivotquery",
			mostraTabella: false,
			nomiMesi: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
			metadati: [
				{ nomeCampo: "nome_attivita", label: "Attività", tipo: "String" },
				{ nomeCampo: "stato", label: "Stato", tipo: "String" },
				{ nomeCampo: "data_ora_effettuata", label: "Data Ora", tipo: "timestamp" },
			],
			campiDisponibili: [],
			config: { righe: [], colonne: [], misure: [] },
			flatHeaders: [],
			dati: [],
			queryResult: [],
			activeFilters: {},
			filterOptions: {},
			keyPivotTable: 0,
		};
	},
	created() {
		let res = [];
		this.metadati.forEach((c) => {
			if (c.tipo === "timestamp") {
				// Aggiunto QUARTER alla lista delle scomposizioni temporali
				["YEAR", "QUARTER", "MONTH", "DAY"].forEach((p) => {
					let labelSuffix = "";
					switch (p) {
						case "YEAR":
							labelSuffix = "Anno";
							break;
						case "QUARTER":
							labelSuffix = "Trimestre";
							break;
						case "MONTH":
							labelSuffix = "Mese";
							break;
						case "DAY":
							labelSuffix = "Giorno";
							break;
					}
					res.push({
						...c,
						uid: c.nomeCampo + p.toLowerCase(),
						label: c.label + " (" + labelSuffix + ")",
						part: p,
					});
				});
			} else {
				res.push({ ...c, uid: c.nomeCampo, label: c.label });
			}
		});
		this.campiDisponibili = res;
		this.initFilters();
	},
	computed: {
		availableFilters() {
			return [...this.config.righe, ...this.config.colonne];
		},
		hasActiveFilters() {
			return Object.values(this.activeFilters).some((v) => v.length > 0);
		},
		filteredData() {
			return this.queryResult.filter((item) => {
				if (item.nome_attivita === "") return false;

				// Filtro dinamico su ogni UID attivo
				for (const uid in this.activeFilters) {
					const selected = this.activeFilters[uid];
					if (selected.length > 0 && !selected.includes(String(item[uid]))) {
						return false;
					}
				}
				return true;
			});
		},
		flatColumnHeaders() {
			const combinations = new Map();
			this.filteredData.forEach((item) => {
				const id = this.config.colonne.map((c) => item[c.uid]).join("_");
				const labels = this.config.colonne.map((c) => this.formatValue(c, item[c.uid]));
				combinations.set(id, { id, labels, topParent: labels[0] });
			});
			return Array.from(combinations.values()).sort((a, b) => a.id.localeCompare(b.id));
		},
		// Genera la struttura ad albero delle testate
		columnTree() {
			const tree = {};

			this.flatColumnHeaders.forEach((col) => {
				let currentNode = tree;
				// Cicla attraverso i livelli di label (Stato, Anno, Mese...)
				col.labels.forEach((label, index) => {
					if (!currentNode[label]) {
						currentNode[label] = {
							name: label,
							children: {},
							span: 0,
						};
					}
					// Se è l'ultimo livello, incrementiamo lo span
					if (index === col.labels.length - 1) {
						// Risaliamo l'albero per incrementare lo span di tutti i genitori
						// (Logica semplificata: lo span finale è il numero di foglie)
					}
					currentNode = currentNode[label].children;
				});
			});
			return tree;
		},

		// Trasforma l'albero in righe per il <thead>
		headerRows() {
			const rows = [];
			const maxLevel = this.config.colonne.length;

			const traverse = (node, level) => {
				if (level >= maxLevel) return;
				if (!rows[level]) rows[level] = [];

				Object.values(node).forEach((item) => {
					// Calcoliamo lo span contando le foglie nel sotto-albero
					const span = this.countLeaves(item.children);
					rows[level].push({ name: item.name, span: span });
					traverse(item.children, level + 1);
				});
			};

			const tree = {}; // Costruzione albero (come sopra)
			this.flatColumnHeaders.forEach((col) => {
				let curr = tree;
				col.labels.forEach((l) => {
					if (!curr[l]) curr[l] = { name: l, children: {} };
					curr = curr[l].children;
				});
			});

			traverse(tree, 0);
			return rows;
		},
		columnGroups() {
			const groups = [];
			let currentGroup = null;
			this.flatColumnHeaders.forEach((h) => {
				if (!currentGroup || currentGroup.name !== h.topParent) {
					currentGroup = { name: h.topParent, span: 0 };
					groups.push(currentGroup);
				}
				currentGroup.span++;
			});
			console.log(groups);
			return groups;
		},
		pivotedData() {
			const rowMap = new Map();
			console.log(this.config);
			const measureUid = "measure_" + this.config.misure[0].uid + "_count";
			console.log(measureUid);
			this.filteredData.forEach((item) => {
				const rowKey = this.config.righe.map((r) => item[r.uid]).join("_");
				if (!rowMap.has(rowKey)) {
					const dims = {};
					this.config.righe.forEach((r) => (dims[r.uid] = item[r.uid]));
					rowMap.set(rowKey, { rowKey, dims, cells: {}, rowTotal: 0 });
				}
				const colKey = this.config.colonne.map((c) => item[c.uid]).join("_");
				const val = parseInt(item[measureUid]) || 0;
				const rowData = rowMap.get(rowKey);
				rowData.cells[colKey] = (rowData.cells[colKey] || 0) + val;
				rowData.rowTotal += val;
			});
			console.log(Array.from(rowMap.values()).sort((a, b) => a.rowKey.localeCompare(b.rowKey)));
			return Array.from(rowMap.values()).sort((a, b) => a.rowKey.localeCompare(b.rowKey));
		},
	},
	methods: {
		initFilters() {
			const filters = {};
			const options = {};
			this.availableFilters.forEach((f) => {
				filters[f.uid] = [];
				const uniqueVals = Array.from(new Set(this.queryResult.map((r) => String(r[f.uid])))).sort();
				options[f.uid] = uniqueVals.map((v) => ({ value: v, text: this.formatValue(f, v) }));
			});
			this.activeFilters = filters;
			this.filterOptions = options;
		},
		countLeaves(node) {
			const keys = Object.keys(node);
			if (keys.length === 0) return 1;
			return keys.reduce((acc, key) => acc + this.countLeaves(node[key].children), 0);
		},
		formatValue(conf, val) {
			if (!val || val === "undefined" || val === "") return "N.D.";
			switch (conf.part) {
				case "YEAR":
					return val;
				case "QUARTER":
					return "Trimestre " + val;
				case "MONTH":
					return this.nomiMesi[parseInt(val) - 1] || "Mese " + val;
				case "DAY":
					return "Giorno " + val;
				default:
					return val;
			}
		},
		// --- DRAG START (SIA DA SORGENTE CHE DA BADGE ESISTENTE) ---
		onDragStartFromSource(event, campo) {
			event.dataTransfer.setData("type", "NEW_FIELD");
			event.dataTransfer.setData("payload", JSON.stringify(campo));
		},
		onDragStartBadge(event, zona, index) {
			event.dataTransfer.setData("type", "REORDER");
			event.dataTransfer.setData("index", index);
			event.dataTransfer.setData("zona", zona);
		},
		onDragOver(event) {
			event.currentTarget.classList.add("drag-over");
		},
		onDragLeave(event) {
			event.currentTarget.classList.remove("drag-over");
		},

		// --- DROP PRINCIPALE SULLA ZONA ---
		onDropMain(event, zonaTarget) {
			console.log("Rilasciato");
			event.currentTarget.classList.remove("drag-over");
			const type = event.dataTransfer.getData("type");

			if (type === "NEW_FIELD") {
				const campo = JSON.parse(event.dataTransfer.getData("payload"));
				this.config[zonaTarget].push({ ...campo, aggregazione: campo.tipo === "numeric" ? "SUM" : "COUNT" });
			}
			this.initFilters();
		},

		// --- DROP SUL BADGE (PER REORDER) ---
		onDropBadge(event, zonaTarget, indexTarget) {
			const type = event.dataTransfer.getData("type");
			const zonaSource = event.dataTransfer.getData("zona");
			const indexSource = parseInt(event.dataTransfer.getData("index"));

			// Funziona solo se stiamo riordinando nella stessa zona
			if (type === "REORDER" && zonaSource === zonaTarget) {
				const items = [...this.config[zonaTarget]];
				const movedItem = items.splice(indexSource, 1)[0];
				items.splice(indexTarget, 0, movedItem);
				this.config[zonaTarget] = items;
			}
		},

		rimuovi(zona, index) {
			console.log("Tutto ok");
			this.config[zona].splice(index, 1);
		},
		analizza() {
			console.log(JSON.stringify(this.config));
			const tempH = [];
			const colValues = this.config.colonne.length > 0 ? ["Gennaio", "Febbraio", "Marzo"] : ["Valore"];
			colValues.forEach((cv) => {
				this.config.misure.forEach((v) => {
					tempH.push({
						title: this.config.colonne.length > 0 ? `${cv} - ${v.aggregazione}(${v.label})` : `${v.aggregazione}(${v.label})`,
						key: cv + v.uid,
					});
				});
			});
			this.flatHeaders = tempH;

			const mock = [];
			for (let i = 0; i < 20; i++) {
				let r = { dims: {}, vals: {} };
				this.config.righe.forEach((dim) => (r.dims[dim.label] = i % 3 === 0 ? "Aperto" : "Chiuso"));
				this.flatHeaders.forEach((h) => (r.vals[h.key] = (Math.random() * 8000).toFixed(2)));
				mock.push(r);
			}
			this.dati = mock;
			this.mostraTabella = true;

			this.loadPivotData();
		},
		loadPivotData() {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResource + "/c71f0936-0220-466d-a002-04a4b3e08ae4";
			axios.put(link, this.config)
				.then((response) => {
					me.queryResult = response.data.data;
					this.initFilters();
					this.keyPivotTable++;
				})
				.catch((e) => {
					console.log(e);
				});
		},
	},
};
</script>

<style scoped>
.sa-flexbox-body-container-content {
	display: flex;
	flex-direction: column;
	height: 100%;
}
.sa-flexbox-body-container-content .row {
	flex: 1;
	height: 100%;
}
.sa-dataanalysis-pivot-wrapper {
	background-color: #f1f3f5;
	min-height: 100vh;
	padding: 20px;
}
.sa-flexbox-body-container-content-center,
.sa-flexbox-body-container-content-left {
	height: 100%;
	overflow: hidden;
}
.sa-flexbox-body-container-content-center {
	display: flex;
	flex-direction: column;
}
/* Sorgente Campi */
.sa-dataanalysis-pivot-filter {
	cursor: move;
	margin-bottom: 8px;
	border-left: 5px solid #007bff;
	background: #ffffff;
	padding: 10px;
	border-radius: 4px;
	font-size: 13px;
	font-weight: 600;
	user-select: none;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
	border-left-color: #ffc107;
	background: #fffdf5;
}
.sa-dataanalysis-pivot-field-source {
	cursor: move;
	margin-bottom: 8px;
	border-left: 5px solid #007bff;
	background: #ffffff;
	padding: 10px;
	border-radius: 4px;
	font-size: 13px;
	font-weight: 600;
	user-select: none;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.sa-dataanalysis-pivot-field-source.is-time {
	border-left-color: #ffc107;
	background: #fffdf5;
}

/* Aree di Atterraggio */
.sa-dataanalysis-pivot-drop-zone {
	min-height: 110px;
	border: 2px dashed #adb5bd;
	border-radius: 8px;
	padding: 10px;
	background: #f8f9fa;
	transition: all 0.2s ease;
}
.sa-dataanalysis-pivot-drop-zone.drag-over {
	border-color: #007bff;
	background: #e7f1ff;
}

/* Badge riordinabili */
.sa-dataanalysis-pivot-badge {
	cursor: move;
	display: inline-block;
	margin: 4px;
}
.sa-dataanalysis-pivot-badge-content {
	display: flex;
	flex-direction: row;
}
/* Tabella Enterprise */
.sa-dataanalysis-pivot-table thead th {
	background-color: var(--bg-sidebar) !important;
	color: #ffffff !important;
	text-transform: uppercase;
	font-size: 0.9rem;
	text-align: center;
	border: 1px solid #454d5566 !important;
}
.sa-dataanalysis-pivot-td-dimension {
	background-color: #f2f2f2 !important;
	font-weight: bold;
	border: 1px solid #dee2e6 !important;
}
.sa-dataanalysis-pivot-td-dim,
.sa-dataanalysis-pivot-td-total {
	background-color: #ddd;
	white-space: nowrap;
}
.sa-dataanalysis-pivot-td-measure {
	background-color: #ffffff !important;
	text-align: right;
	font-family: "Courier New", monospace;
	border: 1px solid #dee2e6 !important;
}

.sa-dataanalysis-pivot-type-tag {
	font-size: 9px;
	color: #6c757d;
	border: 1px solid #dee2e6;
	padding: 1px 4px;
	border-radius: 3px;
}
.sa-dataanalysis-pivot-badge-icon {
	height: 22px;
	width: 22px;
	background-color: transparent;
	font-size: 14px;
	padding-top: 3px;
}
.sa-dataanalysis-pivot-badge {
	font-size: 12px;
}
.sa-dataanalysis-pivot-drop-zone-misure {
	background-color: #f6f2cb;
}
.sa-dataanalysis-pivot-field-source-string {
	border-left: 5px solid #007bff !important;
}
.sa-dataanalysis-pivot-field-source-timestamp {
	border-left: 5px solid #ffbb00 !important;
}
.sa-dataanalysis-pivot-field-source-numeric {
	border-left: 5px solid #1e5e11 !important;
}
.sa-dataanalysis-pivot-field-source:hover {
	transform: translateX(5px);
}

/* 1. Crea un contenitore con altezza definita e scroll */
.sa-dataanalysis-pivot-table-responsive {
	margin-top: 20px;
	max-height: 100%; /* Altezza massima prima dello scroll */
	overflow-y: auto; /* Abilita lo scroll verticale */
	/* padding-bottom: 250px; */
}

.sa-dataanalysis-pivot-table-responsive table {
	width: 100%;
	border-collapse: collapse;
}

/* 2. Fissa l'header in cima */
.sa-dataanalysis-pivot-table-responsive thead th {
	position: sticky;
	top: 0; /* Blocca a 0 pixel dall'alto del contenitore */
	background-color: #f8f9fa; /* Colore obbligatorio per non vedere i dati sotto */
	z-index: 1; /* Mantiene l'header sopra le righe del body */
	box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); /* Opzionale: ombra per profondità */
	vertical-align: middle;
}

/* Stili estetici di base */
.sa-dataanalysis-pivot-table-responsive th,
td {
	padding: 12px;
	text-align: left;
	border-bottom: 1px solid #ddd;
}
.sa-dataanalysis-pivot-dropdown-filter-content {
	padding-left: 15px;
	padding-right: 15px;
	padding-top: 5px;
	padding-bottom: 5px;
	white-space: nowrap;
}
.sa-dataanalysis-pivot-dropdown-filter-content .custom-control {
	margin-bottom: 5px;
}
</style>
